import React, { useState } from "react";
import { useAuth } from "../../contexts/authContext/";
import { addRecord } from "../../firebase/db/configurations/crud.tsx";
import confetti from "canvas-confetti";
import { CountryField, StateField, VisitorAPIComponents } from "react-country-state-fields";

const FormConfigurationModal = ({ isOpen, onClose }) => {
	const { currentUser } = useAuth();
	const [themeClass, setThemeClass] = useState("form-body-classic");
	const [headerText, setHeaderText] = useState("Become a Fan");
	const [buttonText, setButtonText] = useState("Sign Up");
	const [showConfetti, setShowConfetti] = useState<boolean | undefined>(false);
	const [country, setCountry] = useState({ code: "", label: "" }); // the selected country
	const [state, setState] = useState({ code: "", label: "" }); // the selected state
	const [formData, setFormData] = useState({
		first_name: "",
		last_name: "",
		email: "",
		mobile: "",
		modified: null,
		country: "",
		state: "",
		created: null,
		user_id: ""
	});

	if (!isOpen) return null;

	const handleSubmit = (e) => {
		e.preventDefault();
		const newConfig = {
			button_text: buttonText,
			collection: "fans",
			created: new Date(),
			css_class: themeClass,
			header_text: headerText,
			show_confetti: showConfetti
		};
		addRecord(currentUser, newConfig);
		handleClose();
	};

	const handleClose = () => {
		onClose();
	};

	const handleChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	function showConfettiOnSubmit() {
		confetti({
			particleCount: 100,
			spread: 70,
			origin: {
				y: 0.6
			}
		});
	}

	const handleSetHeader = (e) => {
		setHeaderText(e.target.value);
	};

	const handleSetButton = (e) => {
		setButtonText(e.target.value);
	};

	const handleSetShowConfetti = () => {
		if (!showConfetti) {
			showConfettiOnSubmit();
		}
		setShowConfetti(!showConfetti);
	};

	const handleThemeChange = (e) => {
		setThemeClass(e.target.value);
	};

	return (
		<div
			className="fixed inset-0 flex
                        items-center justify-center
                        bg-black bg-opacity-50">
			<div id="large-modal" className="fixed items-center justify-center z-50 p-4 md:inset-0 content-center">
				<div className="relative w-full max-w-4xl max-h-full ml-auto mr-auto">
					<div className="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
						<div className="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
							<h3 className="text-xl font-medium text-grey-700">New Fan Form</h3>
							<button
								onClick={handleClose}
								type="button"
								className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
								data-modal-hide="extralarge-modal">
								<svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
									<path
										stroke="currentColor"
										stroke-linecap="round"
										stroke-linejoin="round"
										stroke-width="2"
										d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
									/>
								</svg>
								<span className="sr-only">Close modal</span>
							</button>
						</div>

						<div className="modal-body flex">
							<div className="w-1/2">
								<form className="p-8 space-y-4">
									<div>
										<label for="theme-selector" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
											Theme
										</label>
										<select
											id="theme-selector"
											value={themeClass}
											onChange={handleThemeChange}
											className="bg-gray-50 border border-white-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-white-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
											<option label="Classic" value="form-body-classic" />
											<option label="Fresh" value="form-body-fresh" />
											<option label="Avocado" value="form-body-avocado" />
										</select>
									</div>
									<div>
										<label for="header-text" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
											Header Text
										</label>
										<input
											defaultValue={headerText}
											onChange={handleSetHeader}
											id="header-text"
											type="text"
											required
											className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
										/>
									</div>
									<div>
										<label for="header-text" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
											Button Text
										</label>
										<input
											defaultValue={buttonText}
											onChange={handleSetButton}
											id="button-text"
											type="text"
											required
											className="w-fullv  mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
										/>
									</div>
									<div>
										<label className="inline-flex items-center cursor-pointer">
											<input onChange={handleSetShowConfetti} type="checkbox" checked={showConfetti} className="sr-only peer" />
											<div className="slider relative w-11 h-6 bg-stone-50 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-stone-50 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"></div>
											<span className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300">Confetti on Submit</span>
										</label>
									</div>
								</form>
							</div>
							<div className="w-1/2">
								<div className={`${themeClass} py-1 mt-0`}>
									<main className="top-auto w-full justify-center content-center flex self-center place-content-center place-items-center">
										<div style={{ transform: `scale(0.8)` }} className="form-panel w-96 space-y-5 p-4 border rounded-xl">
											<div className="text-center mb-6">
												<div className="mt-2">
													<h2 className="text-xl font-semibold sm:text-2xl">{headerText}</h2>
												</div>
											</div>
											<form className="space-y-4">
												<div>
													<label className="text-sm font-bold">First Name</label>
													<input
														type="text"
														required
														className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
													/>
												</div>
												<div>
													<label className="text-sm font-bold">Last Name</label>
													<input
														type="text"
														required
														className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
													/>
												</div>
												<div>
													<label className="text-sm font-bold">Email</label>
													<input
														type="email"
														autoComplete="email"
														required
														className="w-full mt-2 px-3 py-2 text-gray-300 bg-transparent outline-none border focus:border-indigo-600 shadow-sm rounded-lg transition duration-300"
													/>
												</div>
												<VisitorAPIComponents
													handleCountryChange={(countryObj) => setCountry(countryObj)}
													handleStateChange={(stateObj) => setState(stateObj)}>
													<div>
														<label className="text-sm font-bold">Country</label>
														<CountryField label=""></CountryField>
													</div>
													<div>
														<label className="text-sm font-bold">State</label>
														<StateField label=""></StateField>
													</div>
												</VisitorAPIComponents>

												<button
													disabled
													// onClick={showConfettiOnSubmit}
													type="submit"
													className="w-full px-4 py-2 text-white font-medium rounded-lg register-button hover:shadow-xl transition duration-300">
													{buttonText}
												</button>
											</form>
										</div>
									</main>
									<script src="./assets/vendor/canvas-confetti/dist/confetti.browser.js"></script>
								</div>
							</div>
						</div>
						<div className="modal-footer justify-end flex items-center p-4 md:p-5 space-x-3 rtl:space-x-reverse border-t border-gray-200 rounded-b dark:border-gray-600">
							<div className="modal-footer>">
								<button
									onClick={handleClose}
									type="button"
									className="py-2.5 px-5 text-sm font-normal text-gray-600 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
									Cancel
								</button>
								<button
									onClick={handleSubmit}
									type="button"
									className="ml-2 py-2.5 px-5 text-sm font-semibold text-gray-400 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
									Generate Link
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default FormConfigurationModal;
